import { render, staticRenderFns } from "./onlineDetail.vue?vue&type=template&id=2d1629b0&scoped=true"
import script from "./onlineDetail.vue?vue&type=script&lang=js"
export * from "./onlineDetail.vue?vue&type=script&lang=js"
import style0 from "./onlineDetail.vue?vue&type=style&index=0&id=2d1629b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1629b0",
  null
  
)

export default component.exports